import cloneDeep from 'lodash/cloneDeep';
import type { RestMetric, TimeMetric } from '../../../../../../common/types';
import { useMetricResource } from '../../../../../../controllers/metric-resource/index.tsx';

export const addMetric =
	(updatedMetric: TimeMetric) =>
	(previous: RestMetric | null): RestMetric | null => {
		if (!previous) return previous;

		const previousSla = cloneDeep(previous);
		const { timeMetrics } = previousSla;
		const findMetricIndex = timeMetrics.findIndex((metric) => metric.id === updatedMetric.id);

		// it's a new metric
		if (findMetricIndex === -1) {
			timeMetrics.push(updatedMetric);
		} else {
			// existed metric
			timeMetrics.splice(findMetricIndex, 1, updatedMetric);
		}

		return {
			...previousSla,
			timeMetrics,
		};
	};

export const useUpdateMetricResource = () => {
	const [, { update }] = useMetricResource();

	const updateResourceMetric = (updatedMetric: TimeMetric) => update(addMetric(updatedMetric));

	return [{ updateResourceMetric }] as const;
};
